<template>
    <div>
        <p class="headline">
            <v-icon style="margin-top:-5px;">people</v-icon> Users
            <small>list of users</small>
        </p>
        <v-breadcrumbs :items="items">
            <template v-slot:item="props">
                <v-icon v-if="props.item.icon" style="color:#fff;">{{props.item.icon}}</v-icon>
                <v-breadcrumbs-item
                @click.prevent="props.item.href"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <v-card tile class="mt-4">
            <v-card-title>All users
                <v-spacer></v-spacer>
                 <v-text-field
                    class="mr-4"
                    style="max-width: 350px;"
                    dense
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    @click:append="searchNow"
                ></v-text-field>
                <v-btn tile @click.stop="dialog = !dialog" color="primary">Add User</v-btn>
            </v-card-title>
            <v-data-table
                dense
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
                :headers="headers"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
                :items="users"
                :items-per-page="20"
                item-key="id"
                class="elevation-1"
                :footer-props="{
                    itemsPerPageOptions: [10,20,30,50,100,-1]
                }"
                >
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                  edit
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    @click="deleteItem(item)"
                  >
                  delete
                  </v-icon>

                  <v-icon 
                    small 
                    @click="setAppUser(item)">
                    settings_backup_restore
                  </v-icon>
                </template>

                <template v-slot:expanded-item="{headers, item}">
                    <td :colspan="headers.length" class="pa-4">
                        <v-data-table
                            dense
                            :items="item.radios"
                            hide-default-footer
                            item-key="id"
                            :headers="radiosHeaders"
                            class="elevation-1">
                            <template v-slot:top>
                                <v-toolbar flat color="primary" dense class="white--text">
                                    <v-toolbar-title><v-icon style="margin-top:-5px;" class="white--text">radio</v-icon> Radios</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>   
                        </v-data-table>
                    </td>
                </template>

            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="600">
            <v-card tile>
                <v-card-title class="pl-8">{{dialogTitle}}</v-card-title>
                <v-card-text>
                    <v-form ref="radioForm">
                        <v-col>
                            <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field label="Email" v-model="editedItem.email" :rules="serialRules"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field label="Company Name" v-model="editedItem.company_name"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field label="Phone" v-model="editedItem.phone"></v-text-field>
                        </v-col>
                        <v-col v-if="editedIndex == -1">
                            <v-text-field 
                                label="Password" 
                                type="password" 
                                v-model="editedItem.password"
                                :rules="[
                                    () => !!editedItem.password || 'This field is required',
                                    () => !!editedItem.password && editedItem.password.length >= 8 || 'Password at least 8 characters'
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" @click="close" tile>Close</v-btn>
                    <v-btn color="primary" tile class="mr-4" @click.prevent="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog 
            max-width="400"
            v-model="deleteDialog">
            <v-card tile>
                <v-card-title>Are you sure?</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <p class="title">You want to delete this user?</p>
                    <div v-if="shouldDeleteItem" class="user-info">
                        <p class="mb-1">Name: {{shouldDeleteItem.name}}</p>
                        <p class="mb-1">Email: {{shouldDeleteItem.email}}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    
                    <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
                    <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from './axios'
import EventBus from '../../../eventbus'
export default {
    data(){
        return {
            search: '',
            singleExpand:true,
            expanded: [],
            dialog:false,
            dialogTitle:'Add User',
            items: [
                {
                text: "Users",
                disabled: true,
                href: '#',
                icon: 'people'
                }
            ],
            headers:[
                { text: 'ID', value: 'id'},
                { text: 'Name', value:'name'},
                { text: 'Email', value:'email'},
                { text: 'Company Name', value: 'company_name'},
                { text: 'Phone', value: 'phone'},
                { text: 'Created At', value: 'created_at'},
                { text: 'Actions', value: 'action', sortable: false },
                { text: '', value: 'data-table-expand'}
            ],
            radiosHeaders:[
                { text: 'Serial', value: 'serial'},
                { text: 'Name', value:'name'},
                { text: 'Model', value: 'model'},
                { text: 'Credential', value: 'username'},
                { text: 'Created At', value: 'created_at', width: '10%'},
                { text: 'Actions', value: 'action', sortable: false, width: '10%'}
            ],
            users:[],
            selectedGroup:null,
            editedItem:{
                id:0,
                name:'',
                email:'',
                company_name:'',
                phone:'',
                password:'',
                created_at:'',
                updated_at:''
            },
            defaultItem:{
                id:0,
                name:'',
                email:'',
                company_name:'',
                phone:'',
                password:'',
                created_at:'',
                updated_at:''
            },
            loading: false,
            totalItems:0,
            options:{
                user_id: this.$store.getters.getUser,
                token: this.$store.getters.getToken,
                page: 1,
                itemsPerPage: 20,
                sortBy: [],
                sortDesc: [],
                multiSort: true,
                trashed: 'no',
                keyword: ''
            },
            deleteDialog:false,
            isConfirmDelete:false,
            shouldDeleteItem:null,
            editedIndex:-1,
            nameRules: [
                    v => !!v || 'User name is required',
                ],
            serialRules: [
                    v => !!v || 'User email is required',
                ],
        }
    },
    methods:{
        searchNow(){
            this.options.keyword = this.search
        },
        editItem(item){
            this.dialogTitle = 'Edit User'
            this.editedIndex = this.users.indexOf(item)
            this.editedItem = Object.assign({},item)
            this.dialog = true
        },
        deleteItem(item){
            this.shouldDeleteItem = null
            this.shouldDeleteItem = item
            this.deleteDialog = true
        },
        confirmDelete(){
            const index = this.users.indexOf(this.shouldDeleteItem)
            axios.delete('user/'+this.shouldDeleteItem.id,{
                        params:{
                            token: this.$store.getters.getToken
                        }
                    })
                    .then(response=>{
                        this.$store.dispatch('setAlert', response.data.message)
                        this.users.splice(index, 1)
                        this.deleteDialog = false
                    })
           
        },
        deleteDialogClose(){
            this.shouldDeleteItem=null
            this.deleteDialog = false
        },
        save(){
            if(!this.$refs.radioForm.validate()) return
            let formData = {
                name: this.editedItem.name,
                email: this.editedItem.email,
                company_name: this.editedItem.company_name,
                phone: this.editedItem.phone,
                password: this.editedItem.password
            }
            if (this.editedIndex > -1) {
                axios.put('user/'+this.editedItem.id,formData,{
                        params:{ 
                            token: this.$store.getters.getToken
                        }
                    })
                    .then(response=>{
                        this.$store.dispatch('setAlert', response.data.message)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setErrorAlert', error.response.data.message)
                    })
                Object.assign(this.users[this.editedIndex], this.editedItem)
                this.close()
            }else{
                axios.post('user',formData,{
                        params:{
                            token: this.$store.getters.getToken
                        }
                    })
                    .then(response=>{
                        this.$store.dispatch('setAlert', response.data.message)  
                    })
                    .catch(error=>{
                        this.$store.dispatch('setErrorAlert', error.response.data.message)
                    })
                this.editedItem.created_at = this.today()
                this.users.push(this.editedItem)
                this.close()
            }
        },
        close(){
            this.dialog = false
            setTimeout(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                this.dialogTitle = 'Add User'
                this.$refs.radioForm.resetValidation()
            },100)
        },
        today(){
            let today = new Date()
            let dd = today.getDate()
            let mm = today.getMonth() + 1
            let yyyy = today.getFullYear()
            let todayString = dd + '-' + mm + '-' + yyyy
            return todayString
        },
        get(){
            this.loading = true
            axios.get('user', {
                params: this.options
            })
            .then(response=>{
                this.loading = false
                this.users = response.data.users.data
                this.totalItems = response.data.users.total
            })
            .catch(error=>{
                console.log(error.response)
            })
        },
        setAppUser(appuser){
            EventBus.$emit('changeuser', appuser)
            EventBus.$emit('setappuserevent')
            //this.$router.push('/admin/radios/'+appuser.id).catch(()=>{})
        }
    },
    created(){
        this.get()
        localStorage.setItem('previousUrl', localStorage.getItem('currentUrl'))
        localStorage.setItem('currentUrl', '/admin/users');

        let id = this.$route.params.id
        if(id){
            this.search = id
            this.options.sortBy.push(this.search)
        }
    },
    watch:{
        options: {
            handler () {
                this.get()
            },
            deep: true,
        }
    }
}
</script>
<style scoped>
.v-breadcrumbs {
  background-color: #0f4e74;
  padding: 6px 8px;
  color: #fff;
}
.v-breadcrumbs__item {
  color: #fff;
}
.v-card__text, .v-card__title {
    padding: 8px 16px;
}
</style>